// Gymnation custom JavaScript - makes selected featured collection tabs link to collections
// This file is safe to edit and won't be overwritten by theme updates

(function() {
  'use strict';

  // Wait for DOM to be ready and custom elements to be defined
  function initFeaturedCollectionsTabs() {
    // Find all featured-collections-tabs elements
    const tabsElements = document.querySelectorAll('featured-collections-tabs');
    
    tabsElements.forEach(tabsElement => {
      // Add click handler that runs in capture phase to intercept before base class handler
      tabsElement.addEventListener("click", (event) => {
        const tab = event.target.closest('[role="tab"]');
        if (!tab) return;
        
        // Check if this tab is already selected
        if (tab.getAttribute("aria-selected") === "true") {
          const url = tab.getAttribute("data-url");
          if (url) {
            event.preventDefault();
            event.stopPropagation();
            window.location.href = url;
            return;
          }
        }
      }, true); // Use capture phase to run before base class handler
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFeaturedCollectionsTabs);
  } else {
    // DOM is already ready, but wait a bit for custom elements to be defined
    setTimeout(initFeaturedCollectionsTabs, 100);
  }

  // Also handle dynamically added sections (Shopify theme editor, AJAX navigation)
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) { // Element node
          if (node.matches && node.matches('featured-collections-tabs')) {
            initFeaturedCollectionsTabs();
          } else if (node.querySelectorAll) {
            const newTabs = node.querySelectorAll('featured-collections-tabs');
            if (newTabs.length > 0) {
              initFeaturedCollectionsTabs();
            }
          }
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Add data-title attributes to menu links for styling
  function addMenuLinkDataAttributes() {
    // Find all menu links and buttons in header primary nav and menu drawer
    const menuElements = document.querySelectorAll(
      '.header__primary-nav a, .header__primary-nav button, #menu-drawer a, #menu-drawer button, .menu-drawer a, .menu-drawer button'
    );
    
    menuElements.forEach(element => {
      // Get text content, handling nested elements
      let linkText = '';
      if (element.tagName === 'BUTTON') {
        // For buttons, get text from the element or its direct child div
        const textNode = Array.from(element.childNodes).find(node => node.nodeType === 3);
        if (textNode) {
          linkText = textNode.textContent.trim();
        } else {
          linkText = element.textContent.trim();
        }
      } else {
        linkText = element.textContent.trim();
      }
      
      // Add data-title attribute based on link text
      if (linkText && !element.hasAttribute('data-title')) {
        element.setAttribute('data-title', linkText);
      }
    });
  }

  // Initialize menu link attributes
  function initMenuAttributes() {
    // Run immediately
    addMenuLinkDataAttributes();
    
    // Also run after a short delay to catch dynamically loaded content
    setTimeout(addMenuLinkDataAttributes, 500);
    setTimeout(addMenuLinkDataAttributes, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMenuAttributes);
  } else {
    initMenuAttributes();
  }

  // Also observe for dynamically added menu items
  const menuObserver = new MutationObserver(() => {
    addMenuLinkDataAttributes();
  });

  menuObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
